import { Head } from "@inertiajs/react";
import { ReactElement } from "react";
import ModuleAvatar from "@/components/ModuleAvatar";
import DeskLayout from "@/layouts/DeskLayout";

interface ModuleLink {
  key: string;
  label: string;
  path: string;
  icon?: string;
  color?: string;
}

interface Props {
  modules: ModuleLink[];
  current_module: string;
}

export default function Index({ modules }: Props) {
  return (
    <>
      <Head title="الوحدات" />
      <div className="grid grid-cols-3 gap-8 px-12 py-8">
        {modules.map((mod) => (
          <div key={mod.key} className="flex items-center justify-center">
            <a href={mod.path} className="inline-flex flex-col items-center gap-4">
              <div className="flex h-24 w-24 items-center justify-center">
                <ModuleAvatar
                  icon={mod.icon}
                  color={mod.color}
                  size="xl"
                  className="rounded-2xl shadow-sm"
                />
              </div>
              <div className="text-base font-semibold text-foreground">{mod.label}</div>
            </a>
          </div>
        ))}
      </div>
    </>
  );
}

Index.layout = (page: ReactElement) => <DeskLayout hideSidebar>{page}</DeskLayout>;
